// Copyright (c) Move Closer 2022.

import { AsyncComponent } from 'vue'

export const ProductReviewsID = 'productReviews'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const PRODUCT_REVIEWS_KEY = 'ProductReviewsModule'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface ProductReviewsConfig {
  useVendorReviews: boolean
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const PRODUCT_REVIEWS_MODULE_CONFIG_MAP: ProductReviewsConfig = {
  useVendorReviews: false
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum ProductReviewsModuleVersion {
  LoadMore = 'loadMore',
  Paginate = 'paginate'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const productReviewsModuleVersionComponentRegistry: Record<string, AsyncComponent> = {
  [ProductReviewsModuleVersion.LoadMore]: () => import(
    /* webpackChunkName: "modules/ProductReviews" */
    './versions/LoadMore/LoadMore.vue'
  ),
  [ProductReviewsModuleVersion.Paginate]: () => import(
    /* webpackChunkName: "modules/ProductReviews" */
    './versions/Paginate/Paginate.vue'
  )
}
